import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { en, fr, sw, ar, zh, es, de, ja, ko, ru, nl, sv, no, fi, da, pl, tr, hi, pt, vi } from './locales';

// Initialize i18next
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en, fr, sw, ar, zh, es, de, ja, ko, ru, nl, sv, no, fi, da, pl, tr, hi, pt, vi
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    },
    react: {
      useSuspense: false
    }
  });

// Function to change language and reload page
export const changeLanguage = (lng: string) => {
  i18n.changeLanguage(lng).then(() => {
    localStorage.setItem('i18nextLng', lng);
    window.location.reload();
  });
};

export default i18n;